import { render, staticRenderFns } from "./UjianTrial.vue?vue&type=template&id=125ee1c2&scoped=true"
import script from "./UjianTrial.vue?vue&type=script&lang=js"
export * from "./UjianTrial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125ee1c2",
  null
  
)

export default component.exports